/*
 * File: Sidebar.jsx
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:51 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: June 3, 2025 at 11:00 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Components
import { Padding } from '../../Padding';
import { CommunityPanel } from '../../CommunityPanel';

// Constants
import { PANEL_VARIANTS } from '../../CommunityPanel/CommunityPanel';

// Styles
import * as S from './Sidebar.styles';


/**
 * Component
 */

export const Sidebar = ({
	toggleOverlay, className
}) => (
	<S.Sidebar className={className}>
		<Padding>

			{/* Mobile Navigation */}
			<S.MobileNavigation>
				<S.NavigationToggle icon={['far', 'times']} size={1.35} onClick={toggleOverlay} />
			</S.MobileNavigation>

			{/* Community Panel */}
			<CommunityPanel variant={PANEL_VARIANTS.HOME} hideBorder inDrawer />

		</Padding>
	</S.Sidebar>
);


/**
 * Configuration
 */

Sidebar.displayName = 'Sidebar';
Sidebar.propTypes = {
	className: PropTypes.string,
	toggleOverlay: PropTypes.func
};
Sidebar.defaultProps = {
	className: null,
	toggleOverlay: null
};
